import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { HistoryOperation } from '../../models/history-operation.model';

export interface HistoryDialogData {
  historyData: HistoryOperation[];
  operationTitle?: string;
  errorMessage?: string;
}

@Component({
  selector: 'app-history-dialog',
  templateUrl: './history-dialog.component.html',
  styleUrls: ['./history-dialog.component.css']
})
export class HistoryDialogComponent implements OnInit {
  
  historyData: HistoryOperation[] = [];
  operationTitle: string = 'Cronologia Operazioni';
  errorMessage: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<HistoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: HistoryDialogData
  ) {}

  ngOnInit() {
    this.historyData = this.data.historyData || [];
    this.operationTitle = this.data.operationTitle || 'Cronologia Operazioni';
    this.errorMessage = this.data.errorMessage || null;
  }

  /**
   * Chiude la dialog
   */
  close(): void {
    this.dialogRef.close();
  }

  /**
   * Formatta la data per la visualizzazione
   * @param date - Data da formattare
   * @returns Data formattata o stringa vuota se null
   */
  formatDate(date: any): string {
    if (!date) return '';
    
    try {
      const dateObj = new Date(date);
      return dateObj.toLocaleDateString('it-IT', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (error) {
      return String(date);
    }
  }

  /**
   * Verifica se un valore è valido (non null, undefined o vuoto)
   * @param value - Valore da verificare
   * @returns true se il valore è valido
   */
  hasValue(value: any): boolean {
    return value !== null && value !== undefined && value !== '';
  }

  /**
   * Ottiene il numero totale di record
   * @returns Numero totale di record
   */
  getTotalRecords(): number {
    return this.historyData.length;
  }

  /**
   * TrackBy function per ottimizzare il rendering della lista
   * @param index - Indice dell'elemento
   * @param item - Elemento della lista
   * @returns Indice univoco
   */
  trackByIndex(index: number, item: any): number {
    return index;
  }
}